var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _c("v-card-title", { staticClass: "pa-0" }, [
        _c("h4", [
          _vm._v("Onboard " + _vm._s(_vm.allSteps.title) + " Dependencies")
        ])
      ]),
      _vm._v(" "),
      _c("v-card-text", { staticClass: "px-0" }, [
        _c("p", { staticClass: "px-0" }, [
          _vm.stepDependencies.length === 0
            ? _c("span", [
                _vm._v(
                  "\n        This asset has no " +
                    _vm._s(_vm.allSteps.title) +
                    " dependencies to review\n      "
                )
              ])
            : _c("span", [
                _vm._v(
                  "\n        Please review the " +
                    _vm._s(_vm.allSteps.title) +
                    " dependencies values below and\n        make any desired changes\n      "
                )
              ])
        ]),
        _vm._v(" "),
        _vm.stepDependencies.length !== 0
          ? _c("div", [
              _c(
                "div",
                { staticClass: "dependency-table" },
                [
                  _c("sphere-table", {
                    ref: "step-dependencies-table",
                    attrs: {
                      "data-items": _vm.stepDependencies,
                      columns: _vm.tableColumns,
                      name: "Asset Review - Account Dependencies",
                      "table-type": "actionable",
                      "configurable-table-key":
                        "arm-account-dependencies-" +
                        _vm.allSteps.title.toLowerCase().replace(/ /g, "-")
                    },
                    on: { selectionchange: _vm.updateSelection },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "below-header",
                          fn: function(ref) {
                            var props = ref.props
                            return [
                              _c(
                                "span",
                                { staticClass: "header-bulk-actions" },
                                [
                                  [
                                    "ShouldBeOnboarded",
                                    "CanRestartService",
                                    "DisableAutomaticManagement"
                                  ].includes(props.field)
                                    ? _c(
                                        "span",
                                        [
                                          props.field === "ShouldBeOnboarded"
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "font-italic red--text"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  Required:\n                "
                                                  )
                                                ]
                                              )
                                            : _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "font-italic black--text"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  Optional:\n                "
                                                  )
                                                ]
                                              ),
                                          _vm._v(" "),
                                          _vm._l(["Yes", "No"], function(
                                            option
                                          ) {
                                            return _c(
                                              "v-btn",
                                              {
                                                key: option,
                                                staticClass: "sb_btn_solid",
                                                attrs: {
                                                  disabled:
                                                    _vm.selectedItems.length ===
                                                      0 ||
                                                    (props.field !==
                                                      "ShouldBeOnboarded" &&
                                                      !_vm.shouldBeOnboardedFlag),
                                                  small: "",
                                                  color:
                                                    "v-btn--outline primary--text",
                                                  title: option,
                                                  value: option === "Yes"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.setAll(
                                                      props.field,
                                                      option
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(option) +
                                                    "\n                "
                                                )
                                              ]
                                            )
                                          })
                                        ],
                                        2
                                      )
                                    : props.field ===
                                      "DisableAutomaticManagementReason"
                                    ? _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                props.field ===
                                                "DisableAutomaticManagementReason"
                                                  ? _vm.selectedItems.find(
                                                      function(i) {
                                                        return i.DisableAutomaticManagement
                                                      }
                                                    ) !== null
                                                  : true,
                                              expression:
                                                "\n                  props.field === 'DisableAutomaticManagementReason'\n                    ? selectedItems.find(\n                        (i) => i.DisableAutomaticManagement\n                      ) !== null\n                    : true\n                "
                                            }
                                          ]
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "d-inline-flex" },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "font-italic black--text pt-2"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    Optional:\n                  "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("v-text-field", {
                                                staticClass: "mx-2 p-0 mt-1",
                                                attrs: { outline: "" },
                                                on: {
                                                  change: function(newValue) {
                                                    return _vm.setAll(
                                                      props.field,
                                                      newValue
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.disableAutomaticManagementReasonValue,
                                                  callback: function($$v) {
                                                    _vm.disableAutomaticManagementReasonValue = $$v
                                                  },
                                                  expression:
                                                    "disableAutomaticManagementReasonValue"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : props.field === "TaskFolder"
                                    ? _c("div", [
                                        _c(
                                          "span",
                                          { staticClass: "d-inline-flex" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "font-italic black--text pt-2"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Optional:\n                  "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("v-text-field", {
                                              staticClass: "mx-2 p-0 mt-1",
                                              attrs: { outline: "" },
                                              on: {
                                                change: function(newValue) {
                                                  return _vm.setAll(
                                                    props.field,
                                                    newValue
                                                  )
                                                }
                                              },
                                              model: {
                                                value: _vm.taskFolderValue,
                                                callback: function($$v) {
                                                  _vm.taskFolderValue = $$v
                                                },
                                                expression: "taskFolderValue"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              )
                            ]
                          }
                        },
                        {
                          key: "shouldBeOnboardedTemplate",
                          fn: function(ref) {
                            var props = ref.props
                            return [
                              _c(
                                "td",
                                [
                                  _c(
                                    "v-btn-toggle",
                                    {
                                      key: props.dataItem.InstanceId,
                                      staticClass: "my-1",
                                      attrs: { mandatory: "" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                        }
                                      },
                                      model: {
                                        value: props.dataItem.ShouldBeOnboarded,
                                        callback: function($$v) {
                                          _vm.$set(
                                            props.dataItem,
                                            "ShouldBeOnboarded",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "props.dataItem.ShouldBeOnboarded"
                                      }
                                    },
                                    _vm._l(["Yes", "No"], function(option) {
                                      return _c(
                                        "v-btn",
                                        {
                                          key: option,
                                          staticClass: "sb_btn_solid",
                                          attrs: {
                                            small: "",
                                            title: option,
                                            value: option
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.setSingleValue(
                                                props.dataItem,
                                                "ShouldBeOnboarded",
                                                option
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(option) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          }
                        },
                        {
                          key: "canRestartServiceTemplate",
                          fn: function(ref) {
                            var props = ref.props
                            return [
                              _c(
                                "td",
                                [
                                  _c(
                                    "v-btn-toggle",
                                    {
                                      key: props.dataItem.InstanceId,
                                      staticClass: "my-1",
                                      attrs: {
                                        disabled:
                                          props.dataItem.ShouldBeOnboarded ===
                                          "No"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                        }
                                      },
                                      model: {
                                        value: props.dataItem.CanRestartService,
                                        callback: function($$v) {
                                          _vm.$set(
                                            props.dataItem,
                                            "CanRestartService",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "props.dataItem.CanRestartService"
                                      }
                                    },
                                    _vm._l(["Yes", "No"], function(option) {
                                      return _c(
                                        "v-btn",
                                        {
                                          key: option,
                                          staticClass: "sb_btn_solid",
                                          attrs: {
                                            small: "",
                                            title: option,
                                            disabled:
                                              props.dataItem
                                                .ShouldBeOnboarded === "No",
                                            value: option
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.setSingleValue(
                                                props.dataItem,
                                                "CanRestartService",
                                                option
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(option) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          }
                        },
                        {
                          key: "disableAutomaticManagementTemplate",
                          fn: function(ref) {
                            var props = ref.props
                            return [
                              _c(
                                "td",
                                [
                                  _c(
                                    "v-btn-toggle",
                                    {
                                      key: props.dataItem.InstanceId,
                                      staticClass: "my-1",
                                      attrs: {
                                        disabled:
                                          props.dataItem.ShouldBeOnboarded ===
                                          "No"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                        }
                                      },
                                      model: {
                                        value:
                                          props.dataItem
                                            .DisableAutomaticManagement,
                                        callback: function($$v) {
                                          _vm.$set(
                                            props.dataItem,
                                            "DisableAutomaticManagement",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "props.dataItem.DisableAutomaticManagement"
                                      }
                                    },
                                    _vm._l(["Yes", "No"], function(option) {
                                      return _c(
                                        "v-btn",
                                        {
                                          key: option,
                                          staticClass: "sb_btn_solid",
                                          attrs: {
                                            small: "",
                                            title: option,
                                            disabled:
                                              props.dataItem
                                                .ShouldBeOnboarded === "No",
                                            value: option
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.setSingleValue(
                                                props.dataItem,
                                                "DisableAutomaticManagement",
                                                option
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(option) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          }
                        },
                        {
                          key: "disableAutomaticManagementReasonTemplate",
                          fn: function(ref) {
                            var props = ref.props
                            return [
                              _c(
                                "td",
                                [
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          props.dataItem.ShouldBeOnboarded ===
                                            "Yes" &&
                                          props.dataItem
                                            .DisableAutomaticManagement ===
                                            "Yes",
                                        expression:
                                          "\n                  props.dataItem.ShouldBeOnboarded === 'Yes' &&\n                  props.dataItem.DisableAutomaticManagement === 'Yes'\n                "
                                      }
                                    ],
                                    staticClass: "my-1",
                                    attrs: {
                                      value:
                                        props.dataItem
                                          .DisableAutomaticManagementReason,
                                      outline: ""
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                      },
                                      input: function(newValue) {
                                        _vm.setSingleValue(
                                          props.dataItem,
                                          "DisableAutomaticManagementReason",
                                          newValue
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          }
                        },
                        {
                          key: "taskFolderTemplate",
                          fn: function(ref) {
                            var props = ref.props
                            return [
                              _c(
                                "td",
                                [
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          props.dataItem.ShouldBeOnboarded ===
                                          "Yes",
                                        expression:
                                          "props.dataItem.ShouldBeOnboarded === 'Yes'"
                                      }
                                    ],
                                    staticClass: "my-1",
                                    attrs: {
                                      value: props.dataItem.TaskFolder,
                                      outline: ""
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                      },
                                      input: function(newValue) {
                                        _vm.setSingleValue(
                                          props.dataItem,
                                          "TaskFolder",
                                          newValue
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1445482852
                    )
                  })
                ],
                1
              )
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }